import { Accordion } from 'react-bootstrap'
import styled from 'styled-components'

export const AccordionHeader = styled(Accordion.Header)`
  max-width: 100%;
  button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 0px;
    padding-right: 0px;
  }
`

export const AccordionTitle = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100w;
`
export const AccordionDate = styled.div`
  width: auto;
`
export const AccordionIcon = styled.a`
  cursor:pointer;
`

export const Container = styled.div`
  width: 100%;
`;

export const StyledTable = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  margin-bottom: 0;
  background-color: #ffffff;
  border: 1px solid #0066b3;
  border-radius: 4px;
  overflow: hidden;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const TableHeaderRow = styled.tr`

`;

export const Th = styled.th<{ width?: number }>`
  color: #0066b3;
  font-weight: 600;
  padding: 12px 16px;
  border-bottom: none;
  ${({ width }) => width && `width: ${width}px;`}
`;

export const Tr = styled.tr`
  
`;

export const Td = styled.td<{ center?: boolean }>`
  padding: 16px;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  ${({ center }) => center && `text-align: center;`}

  
`;

export const MobileCardList = styled.div`
  display: none;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media (max-width: 767px) {
    display: flex;
  }
`;

export const MobileCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #0066b3;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MobileCardProgramName = styled.span`
  font-weight: 600;
  font-size: 15px;
  color: #111827;
`;

export const MobileCardDates = styled.div`
  display: flex;
  gap: 8px;
  font-size: 13px;
  color: #6b7280;

  span {
    font-weight: 500;
    color: #374151;
  }
`;

export const MobileCardStepSelect = styled.select`
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  outline: none;
  background: #ffffff;
  color: #111827;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px 16px;
  padding-right: 36px;

  &:focus {
    border-color: #6b7280;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  }
`;

export const StepSelect = styled.select`
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  
  outline: none;
  background: #ffffff;
  color: #111827;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px 16px;
  padding-right: 36px;

  &:focus {
    border-color: #6b7280;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  }
`;
